import lazyLoad from '@/primitives/lazy.load.tsx';
import AccountInfo from './info/account-info.tsx';
import AccountList from './list/account-list.tsx';
import EditAccount from './new-edit/edit-account.tsx';
import NewAccount from './new-edit/new-account.tsx';
import AccountSettings from './settings/account-settings.tsx';

const Account = lazyLoad(() => import('./Account.tsx'));

export const accountRoute = {
  path: '/account',
  element: <Account />,
  children: [
    {
      path: 'info/:accountKey?',
      element: <AccountInfo />,
    },
    {
      path: 'new/:organizationKey',
      element: <NewAccount />,
    },
    {
      path: 'edit/:accountKey?',
      element: <EditAccount />,
    },
    {
      path: 'settings/:accountKey?',
      element: <AccountSettings />,
    },
    {
      path: '',
      element: <AccountList />,
    },
  ],
};

export default Account;
